<template>
    <nav class="bot-top-nav">
        <router-link
            v-bind:class="{ 'bot-top-nav__link--active': isActive(button) }"
            :to="{ name: button.path }"
            v-for="(button, index) in buttons"
            v-on:click.prevent="navigate({ name: button.path })"
            v-bind:key="index"
            class="bot-top-nav__link text-uppercase">
            {{ button.name }}
        </router-link>
        <slot name="link"></slot>
    </nav>
</template>

<script>
export default {
    name: "TopNavMenu",
    props:{
        buttons: {
            type: Array,
            required: true
        },
    },
    methods:{
        navigate(path){
            this.$router.push(path);
        },
        isActive(button) {
            return this.$route.name === button.path;
        }
    }
}
</script>

<style scoped>
.bot-top-nav {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 8px;
    background: #ffffff;
    border-bottom: 1px solid #e4eaf2;
    box-shadow: 0 4px 14px rgba(15, 38, 65, 0.06);
    scrollbar-width: thin;
}

.bot-top-nav__link {
    min-height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    padding: 7px 11px;
    border-radius: 8px;
    color: #173b5d;
    font-size: 0.72rem;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 0;
    white-space: nowrap;
}

.bot-top-nav__link:hover,
.bot-top-nav__link--active {
    color: #0f2641;
    background: #e9f0f8;
}

</style>
